import ApiRequest from '../request'

export default class Contracts {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async contractsFromMonday(params) {
    try {
      const res = await this.apiRequest.get(`contracts_frommonday`, params)
      return res
    } catch (error) {
      return error.response
    }
  }
}
